<template>
    <div class="karir">
        <section id="karir" class="karir section bg-light">
            <div class="container section-title" data-aos="fade-up">
                <h2>{{title}}</h2>
            </div>
            <div class="container">
                <div class="row gy-4 justify-content-center">
                    <div class="col-4" data-aos="fade-up" data-aos-delay="100" v-for="item in dataKarir" :key="item.id">
                        <div class="sdgs-item d-flex flex-column align-items-start">
                            <h3 class="h5 mb-2">{{ item.positions }}</h3>
                            <p class="small text-muted">{{ item.type }}</p>
                            <p class="mb-4 text-secondary">{{ item.description }}</p>
                            <ul class="list-unstyled">
                                <li v-for="req in JSON.parse(item.requirements)" :key="req" class="mb-2">
                                    <i class="bi bi-check-circle-fill me-2 text-success"></i>
                                    {{ req }}
                                </li>
                            </ul>
                            <div class="d-grid gap-2 mt-3">
                                <button type="button" class="btn btn-fwi" data-bs-toggle="modal" data-bs-target="#formApply" @click="showModal(item.id)">Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="container justify-content-center">
                <div class="row gy-4 justify-content-center">
                    <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100" v-for="item in dataKarir" :key="item.id">
                        <div class="karir-item shadow-sm p-3 mb-5 bg-white rounded">
                            <h3 class="h5 mb-2">{{ item.positions }}</h3>
                            <p class="small text-muted">{{ item.type }}</p>
                            <p class="mb-4 text-secondary">{{ item.description }}</p>
                            <ul class="list-unstyled">
                                <li v-for="req in JSON.parse(item.requirements)" :key="req" class="mb-2">
                                    <i class="bi bi-check-circle-fill me-2 text-success"></i>
                                    {{ req }}
                                </li>
                            </ul>
                            <div class="d-grid gap-2 mt-3">
                                <button type="button" class="btn btn-fwi" data-bs-toggle="modal" data-bs-target="#formApply" @click="showModal(item.id)">Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </section>
        <!-- Modal Apply -->
        <div class="modal fade" id="formApply" tabindex="-1" aria-labelledby="formApplyLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="formApplyLabel">Form Lamaran</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addApplicant" action="" method="post" enctype="multipart/form-data">
                            <!-- <div class="mb-3">
                                <label for="id" class="form-label">ID Karir</label>
                                <input type="text" class="form-control" id="id" name="id" v-model="dataApply.id_career" required readonly>
                            </div> -->
                            <div class="mb-3">
                                <label for="positions" class="form-label">Posisi</label>
                                <input type="text" class="form-control" id="positions" name="positions" v-model="dataApply.positions" required readonly>
                            </div>
                            <div class="mb-3">
                                <label for="name" class="form-label">Nama</label>
                                <input type="text" class="form-control" id="name" name="name" v-model="dataApply.name" required>
                            </div>
                            <div class="mb-3">
                                <label for="email" class="form-label">Email</label>
                                <input type="email" class="form-control" id="email" name="email" v-model="dataApply.email" required>
                            </div>
                            <div class="mb-3">
                                <label for="phone" class="form-label">No. Telepon</label>
                                <input type="text" class="form-control" id="phone" name="phone" v-model="dataApply.phone" required>
                            </div>
                            <div class="mb-3">
                                <label for="cv" class="form-label">CV (hanya pdf)</label>
                                <input type="file" class="form-control" id="cv" name="cv" accept=".pdf" @change="handleFileChange" required>
                            </div>
                            <div v-if="fileUrl" class="mt-3 text-center">
                                <embed :src="fileUrl" style="width: 100%; height: 500px;" type="application/pdf" />
                            </div>
                            <!-- Tombol & Recaptcha -->
                            <button type="button" class="btn btn-warning" @click="showRecaptcha">Verifikasi</button>

                            <div v-if="isRecaptchaVisible">
                                <div class="g-recaptcha" :data-sitekey="siteKey" data-callback="onRecaptchaSuccess"></div>
                            </div>
                            <br>
                            <button type="submit" class="btn btn-fwi">Apply Now</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import KarirJs from './js/app.js';
export default KarirJs;
</script>

